import axios from 'axios'
import { Message } from 'element-ui'
import config from '@/api/config'

// 创建axios实例
const service = axios.create({
  baseURL: config.baseURL,
  timeout: config.timeout || 10000,
  maxContentLength: Infinity, // 允许无限大的响应内容
  maxBodyLength: Infinity // 允许无限大的请求体（用于文件上传）
})

// 请求拦截器
service.interceptors.request.use(
  config => {
    // 使用localStorage直接获取token，避免引用错误
    const token = localStorage.getItem('token')
    if (token) {
      config.headers.Authorization = `Bearer ${token}`
    }
    // 调试日志：打印请求方法和URL
    if (config.url && config.url.includes('orderemailsinfo') && !config.url.includes('list')) {
      console.log('🔍 请求拦截器 - URL:', config.url)
      console.log('🔍 请求拦截器 - Method:', config.method)
      console.log('🔍 请求拦截器 - 完整配置:', {
        url: config.url,
        method: config.method,
        baseURL: config.baseURL
      })
    }
    return config
  },
  error => {
    console.error('请求错误:', error)
    return Promise.reject(error)
  }
)

// 响应拦截器
service.interceptors.response.use(
  response => {
    const { data } = response
    // console.log('API响应拦截器收到数据:', data)

    // 根据记忆中的规则，API应该返回包含code字段的JSON
    if (data.code === 200) {
      // console.log('API响应成功:', data)
      return data
    } else {
      console.error('API响应失败:', data)
      // 恢复底层的错误显示
      Message.error(data.msg || '请求失败')
      return Promise.reject(new Error(data.msg || '请求失败'))
    }
  },
  error => {
    console.error('响应错误:', error)
    console.error('错误详情:', {
      message: error.message,
      code: error.code,
      response: error.response,
      request: error.request
    })

    if (error.response) {
      const { status, data } = error.response
      console.error(`HTTP ${status} 错误:`, data)

      switch (status) {
        case 401:
          Message.error('登录已过期，请重新登录')
          // 直接清除localStorage中的认证信息
          localStorage.removeItem('token')
          localStorage.removeItem('userInfo')
          // 可选：跳转到登录页面
          if (window.location.pathname !== '/') {
            window.location.href = '/'
          }
          break
        case 403:
          Message.error('拒绝访问')
          break
        case 404:
          Message.error('请求的资源不存在')
          break
        case 500:
          Message.error('服务器内部错误')
          break
        default:
          Message.error(data?.msg || `HTTP ${status} 错误`)
      }
    } else if (error.request) {
      console.error('请求已发送但没有收到响应:', error.request)
      Message.error('服务器无响应，请检查网络连接')
    } else {
      console.error('请求配置错误:', error.message)
      Message.error('请求配置错误')
    }

    return Promise.reject(error)
  }
)

export default service

// Token和用户信息管理工具函数
export const tokenUtils = {
  // 获取token
  getToken () {
    return localStorage.getItem('token')
  },

  // 设置token
  setToken (token) {
    if (token) {
      localStorage.setItem('token', token)
      return true
    }
    return false
  },

  // 清除token
  removeToken () {
    localStorage.removeItem('token')
  },

  // 检查token是否存在
  hasToken () {
    return !!localStorage.getItem('token')
  },

  // 获取用户信息
  getUserInfo () {
    const userInfo = localStorage.getItem('userInfo')
    return userInfo ? JSON.parse(userInfo) : null
  },

  // 设置用户信息
  setUserInfo (userInfo) {
    if (userInfo) {
      localStorage.setItem('userInfo', JSON.stringify(userInfo))
      return true
    }
    return false
  },

  // 清除用户信息
  removeUserInfo () {
    localStorage.removeItem('userInfo')
  },

  // 清除所有认证信息（token和用户信息）
  clearAuth () {
    this.removeToken()
    this.removeUserInfo()
  }
}
